import { useEffect, useRef } from 'react'
import Snap from 'snapsvg-cjs'
import Graph from 'library/Graph'
import Lib from 'library'

const LineGraph = ({ data, className = "line-graph", height = 150, option }) => {

	const svg = useRef()
	//  data = [[
	// 	{ key: "05.23", value: "27", label: "" },
	// 	{ key: "05.24", value: "24", label: "" },
	// 	{ key: "05.25", value: "28", label: "" },
	// 	{ key: "05.26", value: "18", label: "" },
	// 	{ key: "05.27", value: "27", label: "" },
	// 	{ key: "05.28", value: "35", label: "" },
	// 	{ key: "05.29", value: "57", label: "" },
	// ],
	// [
	// 	{ key: "05.23", value: "17", label: "" },
	// 	{ key: "05.24", value: "19", label: "" },
	// 	{ key: "05.25", value: "20", label: "" },
	// 	{ key: "05.26", value: "5", label: "" },
	// 	{ key: "05.27", value: "3", label: "" },
	// 	{ key: "05.28", value: "13", label: "" },
	// 	{ key: "05.29", value: "52", label: "" },
	// ]] 

	option = {
		...{
			xAxis: true,
			yAxis: false,
			label: true,
			sideValue: false,
			padding: "10 0 45 0",
			xDivision: 0,
			yDivision: 4,
			innerLeft: 30,
			innerRight: 30,
			strokeWidth: 2,
			dotRadius: 10,
		}, ...option
	}

	// console.log(option)

	const draw = () => {
		const paper = Snap(svg.current)

		const {
			width,
			height,
			paddingTop,
			paddingLeft,
			graphWidth,
			graphHeight,
			cap
		} = Graph.init(svg.current, data, option)

		const gridStyle = { stroke: "#D9D9D9", strokeWidth: 1, strokeDasharray: "4 7" }
		const textStyle = { dominantBaseline: "middle", alignmentBaseline: "middle", textAnchor: "end" }
		const filter = paper.filter(Snap.filter.shadow(0, 2, 6, "#129848", 0.3))

		// outter frame
		/* paper.rect(0, 0, width, height)
			.attr({
				fill: 'transparent',
				stroke: "#ccc",
				strikeWidth: 2
			}) */

		const gridGroup = paper.g({ name: "gridGroup" })
		const valueGroup = paper.g({ name: "valueGroup" })
		const axisGroup = paper.g({ name: "axisGroup" })
		const lineGroup = paper.g({ name: "lineGroup" })
		const dotsGroup = paper.g({ name: "dotsGroup" }).attr({ filter: filter })
		const balloonGroup = paper.g({ name: "balloonGroup" })
		// balloonGroup.rect(-25, -10, 50, 20, 10, 10).attr({ fill: "#444" })
		balloonGroup.transform("translate(-100, -100)")
		const balloonText = balloonGroup.text(0, 0, "haha").attr({ ...textStyle, textAnchor: "middle", fill: "#333", alignmentBaseline: "middle" })

		// grid x
		if (option.xDivision) {
			const span = graphWidth / option.xDivision
			for (let i = 0; i < option.xDivision; i++) {
				const line = paper.line(span * (i + 1) + paddingLeft, paddingTop, span * (i + 1) + paddingLeft, paddingTop + graphHeight)
				line.attr(gridStyle).appendTo(gridGroup)
			}
		}

		// grid y
		if (option.yDivision) {
			const span = graphHeight / option.yDivision
			for (let i = 0; i < option.yDivision; i++) {
				const line = paper.line(paddingLeft, span * i + paddingTop, paddingLeft + graphWidth, span * i + paddingTop)
				line.attr(gridStyle).appendTo(gridGroup)
				if (option.valueGroup) {
					const value = Math.round(cap / option.yDivision * (option.yDivision - i) * 100) / 100
					const text = paper.text(paddingLeft - 5, span * i + paddingTop, value)
					text.attr(textStyle).appendTo(valueGroup)

					if (i === option.yDivision - 1) {
						const text = paper.text(paddingLeft - 5, span * (i + 1) + paddingTop, "0")
						text.attr(textStyle).appendTo(valueGroup)
					}
				}
			}
		}

		// axis y
		if (option.yAxis) {
			const line = paper.line(paddingLeft, paddingTop, paddingLeft, paddingTop + graphHeight)
			line.attr({
				stroke: "red",
				strokeWidth: 1
			}).appendTo(axisGroup)
		}

		// axis x
		if (option.xAxis) {
			const line = paper.line(paddingLeft, paddingTop + graphHeight, paddingLeft + graphWidth, paddingTop + graphHeight)
			line.attr({
				stroke: "#D9D9D9",
				strokeWidth: 2
			}).appendTo(axisGroup)
		}

		// labels && graph
		const unit = !cap || cap === 0 ? 0 : graphHeight / cap;
		const span = (graphWidth - option.innerLeft - option.innerRight) / (data[0].length - 1)
		const easing = window.mina.backout
		const delay = 1000
		const duration = 700

		data.forEach((d, idx) => {

			d.reduce((prev, now, i) => {

				let dot
				const dotGroup = dotsGroup.g({ name: "dotGroup" })
				if (idx === 0) {
					dot = paper.circle(0, 0, option.dotRadius / 2)
				} else {
					dot = paper.rect(-option.dotRadius / 2, -option.dotRadius / 2, option.dotRadius, option.dotRadius)
				}
				const to = graphHeight - (now.value * unit) + paddingTop
				const x = span * i + paddingLeft + option.innerLeft
				dotGroup.circle(0, 0, option.dotRadius).attr({ fill: "transparent" })
				dotGroup.transform(`translate(${x}, ${paddingTop + graphHeight})`)
				dot.attr({
					fill: idx === 0 ? "white" : "silver",
					stroke: i === d.length - 1 ? "#32C96E" : "#D9D9D9",
					strokeWidth: 4
				})
					.appendTo(dotGroup)
				dotGroup.data("data", `${now.value},${now.flrCnt},${now.ddcar}`).click(function (e) {
					const data = this.data("data").split(",")

					if (data.length > 0) {
						balloonText.node.innerHTML = `<tspan x="0" fill="#32C96E" font-weight="600">${Lib.numberToKorean(data[0])}</tspan>`;
					} else {
						balloonText.node.innerHTML = `<tspan x="0" fill="#32C96E" font-weight="600">${Lib.numberToKorean(data[0])}</tspan>
						<tspan x="0" dy="1.5rem">${data[1]}층 ${data[2]}m</tspan><tspan font-size="1rem" dy="-0.5rem">2</tspan>`
					}

					balloonGroup.animate({
						transform: `translate(${e.offsetX}, ${e.offsetY + 27})`
					}, 200, easing)
				})

				if (option.label) {
					const labelGroup = paper.g({ name: "labelGroup" })
					const label = paper.text(span * i + paddingLeft + option.innerLeft, paddingTop + graphHeight + 18, now.key)
					label.attr({
						textAnchor: "middle", dominantBaseline: "hanging", alignmentBaseline: "middle",
						fill: i === d.length - 1 ? "#32C96E" : "#999",
						fontWeight: i === d.length - 1 ? "600" : "500",
						fontSize: "12"
					})
					const g = paper.g(label)
					// g.transform("rotate(45deg)")
					g.appendTo(labelGroup)
				}


				if (prev) {
					const line = paper.line(isNaN(prev[0]) ? 0 : prev[0], paddingTop + graphHeight, span * i + paddingLeft + option.innerLeft, paddingTop + graphHeight).appendTo(lineGroup)
					const y1 = isNaN(prev[1]) ? 0 : prev[1]
					const y2 = graphHeight - (now.value * unit) + paddingTop
					line.attr({
						stroke: idx === 0 ? "#D9D9D9" : "silver",
						strokeWidth: option.strokeWidth
					})

					setTimeout(() => {
						dotGroup.animate({
							transform: `translate(${x}, ${to})`
						}, duration, easing)

						line.animate({
							y1: isNaN(y1) ? 0 : y1,
							y2: isNaN(y2) ? 0 : y2
						}, duration, easing)
					}, delay)
				} else {
					setTimeout(() => {
						dotGroup.animate({
							transform: `translate(${x}, ${to})`
						}, duration, easing)
					}, delay)
				}
				return [
					span * i + paddingLeft + option.innerLeft,
					graphHeight - (now.value * unit) + paddingTop
				]
			}, null)

		})

	}

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(draw, [])

	return (
		<svg ref={svg} className={className} style={{ height: height, width: "100%" }} />
	)
}

export default LineGraph